import produce from 'immer';
import {State, Actions} from './interfaces';
import {
  GET_CENTERS,
  GET_CENTERS_SUCCESS,
  GET_CENTERS_FAILED,
  GET_CENTERS_WITH_ID,
  GET_CENTERS_WITH_ID_SUCCESS,
  GET_CENTERS_WITH_ID_FAILED,
  GET_USERS_BY_CENTERS_ID,
  GET_USERS_BY_CENTERS_ID_SUCCESS,
  GET_USERS_BY_CENTERS_ID_FAILED,
  GET_USERS_BE_ADMIN_CENTER,
  GET_USERS_BE_ADMIN_CENTER_SUCCESS,
  GET_USERS_BE_ADMIN_CENTER_FAILED,
  GET_ALL_CENTERS_REPORT,
  GET_ALL_CENTERS_REPORT_SUCCESS,
  GET_ALL_CENTERS_REPORT_FAILED,
  GET_ALL_SUPERVISORS,
  GET_ALL_SUPERVISORS_SUCCESS,
  GET_ALL_SUPERVISORS_FAILED,
  UPDATE_CENTER_STATUS,
  UPDATE_CENTER_STATUS_SUCCESS,
  UPDATE_CENTER_STATUS_FAILED,
  GET_CENTERS_ACTIVE_COUNT,
  GET_CENTERS_ACTIVE_COUNT_SUCCESS,
  GET_CENTERS_ACTIVE_COUNT_FAILED,
  GET_CENTERS_DEACTIVE_COUNT,
  GET_CENTERS_DEACTIVE_COUNT_SUCCESS,
  GET_CENTERS_DEACTIVE_COUNT_FAILED,
  GET_CENTERS_STATISTICS,
  GET_CENTERS_STATISTICS_SUCCESS,
  GET_CENTERS_STATISTICS_FAILED,
  GET_CENTERS_STATISTICS_WITH_ID,
  GET_CENTERS_STATISTICS_WITH_ID_SUCCESS,
  GET_CENTERS_STATISTICS_WITH_ID_FAILED,
} from './constants';

export const initialState: State = {
  centersList: [],
  supervisorsList: [],
  allCentersReportList: [],
  usersByCenterId: [],
  usersBeAdminCenter: [],
  center: [],
  centersStatisticsList: [],
  centersStatisticsListCount: 0,
  centersStatistic: [],
  count: 0,
  countActive: 0,
  countDeactive: 0,
  loading: false,
  error: '',
};


export const CentersReducer = (state = initialState, action: Actions) =>
  produce(state, draft => {
    switch (action.type) {
      case GET_ALL_CENTERS_REPORT:
        draft.loading = true;
        break;
      case GET_ALL_CENTERS_REPORT_SUCCESS:
        draft.allCentersReportList = action.data
        draft.loading = false;
        break;
      case GET_ALL_CENTERS_REPORT_FAILED:
        draft.loading = false;
        break;
      case GET_CENTERS:
        draft.loading = true;
        break;
      case GET_CENTERS_SUCCESS:
        draft.centersList = action.data;
        draft.allCentersReportList = [];
        draft.count = action.count;
        draft.loading = false;
        break;
      case GET_CENTERS_FAILED:
        draft.error = action.error;
        draft.loading = false;
        break;

      case GET_CENTERS_STATISTICS:
        draft.loading = true;
        break;
      case GET_CENTERS_STATISTICS_SUCCESS:
        draft.centersStatisticsList = action.data;
        draft.centersStatisticsListCount = action.count;
        draft.loading = false;
        break;
      case GET_CENTERS_STATISTICS_FAILED:
        draft.error = action.error;
        draft.loading = false;
        break;

      case GET_CENTERS_STATISTICS:
        draft.loading = true;
        break;
      case GET_CENTERS_STATISTICS_SUCCESS:
        draft.centersList = action.data;
        draft.loading = false;
        break;
      case GET_CENTERS_STATISTICS_FAILED:
        draft.error = action.error;
        draft.loading = false;
        break;

      case GET_CENTERS_STATISTICS_WITH_ID:
        draft.loading = true;
        break;
      case GET_CENTERS_STATISTICS_WITH_ID_SUCCESS:
        draft.centersStatistic = action.data;
        draft.loading = false;
        break;
      case GET_CENTERS_STATISTICS_WITH_ID_FAILED:
        draft.error = action.error;
        draft.loading = false;
        break;

      case GET_CENTERS_WITH_ID:
        draft.loading = true;
        break;
      case GET_CENTERS_WITH_ID_SUCCESS:
        draft.center = action.data;
        draft.loading = false;
        break;
      case GET_CENTERS_WITH_ID_FAILED:
        draft.error = action.error;
        draft.loading = false;
        break;

      case GET_USERS_BY_CENTERS_ID:
        draft.loading = true;
        break;
      case GET_USERS_BY_CENTERS_ID_SUCCESS:
        draft.usersByCenterId = action.data;
        draft.loading = false;
        break;
      case GET_USERS_BY_CENTERS_ID_FAILED:
        draft.error = action.error;
        draft.loading = false;
        break;
      case GET_USERS_BE_ADMIN_CENTER:
        draft.loading = true;
        break;
      case GET_USERS_BE_ADMIN_CENTER_SUCCESS:
        draft.usersBeAdminCenter = action.data;
        draft.loading = false;
        break;
      case GET_USERS_BE_ADMIN_CENTER_FAILED:
        draft.error = action.error;
        draft.loading = false;
        break;

      case GET_ALL_SUPERVISORS:
        draft.loading = true;
        break;
      case GET_ALL_SUPERVISORS_SUCCESS:
        draft.supervisorsList = action.data;
        draft.loading = false;
        break;
      case GET_ALL_SUPERVISORS_FAILED:
        draft.error = action.error;
        draft.loading = false;
        break;

      case UPDATE_CENTER_STATUS:
        draft.loading = true;
        break;
      case UPDATE_CENTER_STATUS_SUCCESS:
        draft.loading = false;
        break;
      case UPDATE_CENTER_STATUS_FAILED:
        draft.error = action.error;
        draft.loading = false;
        break;

      case GET_CENTERS_ACTIVE_COUNT:
        draft.loading = true;
        break;
      case GET_CENTERS_ACTIVE_COUNT_SUCCESS:
        draft.countActive = action.count;
        draft.loading = false;
        break;
      case GET_CENTERS_ACTIVE_COUNT_FAILED:
        draft.error = action.error;
        draft.loading = false;
        break;

      case GET_CENTERS_DEACTIVE_COUNT:
        draft.loading = true;
        break;
      case GET_CENTERS_DEACTIVE_COUNT_SUCCESS:
        draft.countDeactive = action.count;
        draft.loading = false;
        break;
      case GET_CENTERS_DEACTIVE_COUNT_FAILED:
        draft.error = action.error;
        draft.loading = false;
        break;

      default:
        break;
    }
  });
export default CentersReducer;
